module.exports = __webpack_public_path__ + "static/img/jdfwphone.fd665e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jdfwphone.png
// module id = Cggd
// module chunks = 1